import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { SharedService } from '../../shared.service';

@Component({
  selector: 'app-subdelears',
  templateUrl: './subdelears.component.html',
  styleUrls: ['./subdelears.component.css']
})
export class SubdelearsComponent implements OnInit {

  delearForm: FormGroup;
  searchString: any = '';

  toggle = true;
  loading = false;
  error: any;
  delearId:any;

  project = JSON.parse(localStorage.getItem('project') || '');

  subdelears:any;
  delear:any;
  currentUser:any;

  constructor(
    private route: ActivatedRoute,
    private SharedService: SharedService,
    private _formBuilder: FormBuilder,
  ) { }

  ngOnInit(): void {
    this.toggle = true;
    this.currentUser = this.SharedService.getUser();
    this.delearForm = this._formBuilder.group({
      _id:[null],
      name: ['', [Validators.required]],
      company_name: ['', [Validators.required]],
      contact: ['', [Validators.required]],
      email: ['',[Validators.required]],
      comission: ['', [Validators.required]],
      rera_number: ['', [Validators.required]],
      address: ['', [Validators.required]],
      project: [''],
      delear: [''],
    });

    this.route.fragment.subscribe((fragment: string) => {
      this.delearId = fragment;
      this.SharedService.getDelaer(this.delearId).subscribe((resp:any)=>{
        this.delear = resp.data;
        console.log(this.delear)
      })
      this.SharedService.getSubdelaers(this.delearId).subscribe((resp:any)=>{
        this.subdelears = resp.data;
        console.log(this.subdelears)
      })
    })
  }

  back(){
    this.toggle = !this.toggle;
    this.delearForm.reset();
  }

  edit(delear:any){
    this.delearForm.patchValue(delear);
    this.toggle = false;
  }

  export(){

  }

  onSubmit(): any {
    if (this.delearForm.invalid) {
      this.Toast.fire({
        title: 'Error!',
        text: 'Please fill all required fields',
        icon: 'error'
      })
      return
    }
     else if(!this.delearForm.value._id) {
      this.loading = true;
      this.delearForm.patchValue({project: this.project._id})
      this.delearForm.patchValue({delear: this.delear._id})
      console.log(this.delearForm.value)
      this.SharedService.CreateSubdelaer(this.delearForm.value).subscribe((response) => {
        console.log(response);
        this.Toast.fire({
          title: 'Done!',
          text: 'Sub broker has been created',
          icon: 'success'
        })
        this.loading = false;
        window.scrollTo(0, 0);
        this.ngOnInit();

      },
        (error) => {
          console.log(error);
          this.Toast.fire({
            title: 'Error!',
            text: error.error.message,
            icon: 'error'
          })
          this.loading = false;
        })
    }else if(this.delearForm.value._id) {
      this.loading = true;
      this.SharedService.UpdateSubdelaer(this.delearForm.value._id,this.delearForm.value).subscribe((response) => {
        console.log(response);
        this.Toast.fire({
          title: 'Done!',
          text: 'Channel partner has been updated',
          icon: 'success'
        })
        this.loading = false;
        window.scrollTo(0, 0);
        this.ngOnInit();

      },
        (error) => {
          console.log(error);
          this.Toast.fire({
            title: 'Error!',
            text: error.error.message,
            icon: 'error'
          })
          this.loading = false;
        })
    }
  }

  Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  })

}
